/**
 * Billing banner component
 * Displays warning when balance is 0 or insufficient
 */
import React from 'react';
import { useBilling } from '@/hooks/useBilling';
import { AlertTriangle, X } from 'lucide-react';

export function BillingBanner() {
  const { balance, loading } = useBilling();
  const [dismissed, setDismissed] = React.useState(false);

  // Don't show if loading, dismissed, or balance > 0
  if (loading || dismissed || !balance || balance.balance > 0) {
    return null;
  }

  return (
    <div className="bg-red-50 border-b border-red-200 px-4 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-red-800">
              Hệ thống tạm thời không thể tạo hình ảnh
            </p>
            <p className="text-sm text-red-700">
              Số dư tài khoản đã hết. Vui lòng liên hệ admin để nạp tiền.
            </p>
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-red-600 hover:text-red-800 flex-shrink-0"
          aria-label="Đóng cảnh báo"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}

